import { gql } from '@apollo/client'

const DELETE_REJECT_REASON = gql`
  mutation DELETE_REJECT_REASON($rejectReason: ID!, $mergeTo: ID!) {
    deleteRejectReason(rejectReason: $rejectReason, mergeTo: $mergeTo) {
      id
    }
  }
`

export default DELETE_REJECT_REASON
